const Stat = () => import(/* webpackChunkName: "stat-group" */ '@/views/stat/Stat')
const ProgressStat = () => import(/* webpackChunkName: "stat-group" */ '@/views/stat/ProgressStat')
const SubjectStat = () => import(/* webpackChunkName: "stat-group" */ '@/views/stat/SubjectStat')
const SdvStat = () => import(/* webpackChunkName: "stat-group" */ '@/views/stat/SdvStat')
const QueryStat = () => import(/* webpackChunkName: "stat-group" */ '@/views/stat/QueryStat')

export default [
  {
    path: 'stat',
    name: 'stat',
    components: {
      studyContent: Stat
    },
    meta: {
      title: '统计汇总'
    },
    redirect: { name: 'progress-stat' },
    children: [
      {
        path: 'progress',
        name: 'progress-stat',
        components: {
          statContent: ProgressStat
        },
        meta: {
          title: '研究进度'
        }
      },
      {
        path: 'subject',
        name: 'subject-stat',
        components: {
          statContent: SubjectStat
        },
        meta: {
          title: '受试者构成'
        }
      },
      {
        path: 'sdv',
        name: 'sdv-stat',
        components: {
          statContent: SdvStat
        },
        meta: {
          title: 'SDV汇总'
        }
      },
      {
        path: 'query',
        name: 'query-stat',
        components: {
          statContent: QueryStat
        },
        meta: {
          title: '疑问汇总'
        }
      }
    ]
  }
]
